exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete{width:100%}.autocomplete-result{padding:5px 10px;border-bottom:1px dotted #ccc}.autocomplete-result:last-child{border-bottom:none}.autocomplete-result.is-active,.autocomplete-result:hover{background:#bbb;color:#fff;cursor:pointer}.autocomplete ul{background:#fff;width:auto;z-index:10;border:1px solid #ccc;list-style:none;margin:0;padding:0;position:absolute;width:calc(100% - 30px)}", ""]);

// exports
